module.exports = __webpack_public_path__ + "static/media/stockhausen_blicke_55.051fc632.jpg";